// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__Ya0cb","main":"MainLayout_main__zUrpc"};